module.exports = __webpack_public_path__ + "static/6305-woodrose-8-38c2a5eb6ba8ac14bf3cb12c2d6e3543.jpg";